import { useState } from 'react';
import { Filter } from 'api/notifications';
import { useTranslation } from 'hooks/use-translation';
import { Option } from './filters';

export const useFilters = () => {
  const [selected, onChange] = useState(Filter.All);
  const options: Option<Filter>[] = [
    {
      label: useTranslation('all'),
      value: Filter.All,
    },
    {
      label: useTranslation('notifications.filters.assignee_me'),
      value: Filter.AssignedToMe,
    },
    {
      label: useTranslation('notifications.filters.mentions'),
      value: Filter.Mentions,
    },
    {
      label: useTranslation('notifications.filters.assignee_team'),
      value: Filter.AssignedToTeam,
    },
  ];

  return { selected, onChange, options };
};
